// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__TqKLN","subTitleBold":"BoxSubTitle_subTitleBold__m6QDm"};